<template>
  <b-modal
    ref="modal"
    title="Novo Acompanhamento Externo"
    size="md"
    ok-title="Salvar"
    cancel-title="Cancelar"
    @ok="onSaveClicked($event)"
  >
    <b-form>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Descrição">
            <b-form-textarea
              v-model="monitoring.description"
              v-validate="rules.description"
              type="text"
              class="form-control"
              :rows="4"
              :max-rows="4"
              aria-describedby="invalidDescription"
              name="description"
              :state="validateState('description')"
            ></b-form-textarea>
            <b-form-invalid-feedback id="invalidDescription">
              {{ errors.first("description") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import { createOmbudsmanMonitoring } from "@/api/ombudsman";

export default {
  name: "OmbudsmanMonitoringModal",
  props: {
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      monitoring: {},
      rules: {
        description: { required: true },
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    async onSaveClicked(bvEvt) {
      bvEvt.preventDefault();
      const validated = await this.$validator.validateAll();

      if (!validated) {
        return;
      }

      try {
        await createOmbudsmanMonitoring(this.record._id, this.monitoring);
      } catch (error) {
        if (error.response.status === 403 || error.response.status === 404) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
        return;
      }

      this.$bvToast.toast("Acompanhamento Externo criado com sucesso!", {
        title: "Sucesso",
        toastClass: "custom-toast custom-toast-success",
        variant: "light",
        solid: true,
        autoHideDelay: 5000,
        noCloseButton: false,
      });
      this.$emit("new-monitoring");

      this.$refs.modal.hide();
    },

    show() {
      this.$refs.modal.show();
    },
  },
};
</script>
